import facultadesFromJson from './facultades_UC.json';
import unidadesFromJson from './unidades_academicas.json';

export const unidadesData: string[] = Array.from(new Set(unidadesFromJson));

export const facultadesData: string[] = Array.from(new Set(facultadesFromJson));

export const affiliationsData: string[] = Array.from(
  new Set(facultadesData.concat(unidadesData).concat('TODAS'))
);
